import {
	Typography,
} from '@mui/material'
import {
	memo,
} from 'react'

import type {
	ITypographyCutProps,
} from './typography-cut.types'

export const TypographyCut = memo((props: ITypographyCutProps) => {
	const {
		children,
		maxWidth,
		...others
	} = props

	return (
		<Typography
			sx={{
				maxWidth,
				overflow:     'hidden',
				textOverflow: 'ellipsis',
				whiteSpace:   'nowrap',
			}}
			{...others}
		>
			{children}
		</Typography>
	)
})
